import moment from 'moment';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { Button, Headline, PageWrapper } from 'libs/ui';
import { Container, DateTime, DoubleField, required, WhiteStyledField, DateSelect } from 'libs/form';

export const TestForm = (props) => {
  const { handleSubmit, change } = props;
  const t = useTranslation();
  const requiredT = required(t);

  const submit = (values) => {
    console.log('🚀 ~ submit ~ out:', values);
    return Promise.resolve();
  };

  const name = 'date';
  const fn1 = name + '_from';
  const fn2 = name + '_to';

  const name2 = 'date2';
  const fn21 = name2 + '_from';
  const fn22 = name2 + '_to';

  return (
    <PageWrapper>
      <Headline>Test</Headline>
      <br />

      <form onSubmit={handleSubmit(submit)}>
        <WhiteStyledField className="shortfield" type="dateTime" label="Дата действия с" placeholder="Дата действия с" name="start_at" validate={requiredT} />
        <br />
        <DateSelect from_name={fn1} to_name={fn2} change={change}>
          <DoubleField>
            <DateTime width="160px" name={fn1} type="dateTime" label={'Дата'} />
            <DateTime width="160px" name={fn2} type="dateTime" />
          </DoubleField>
        </DateSelect>

        <br />
        <Container theme="dark">
          <DateSelect from_name={fn21} to_name={fn22} change={change} theme="dark">
            <DoubleField>
              <DateTime width="160px" name={fn21} type="dateTime" label={'Дата'} theme="dark" />
              <DateTime width="160px" name={fn22} type="dateTime" theme="dark" />
            </DoubleField>
          </DateSelect>
        </Container>

        <br />
        <br />
        <Button type="submit">Save</Button>
      </form>
    </PageWrapper>
  );
};

const d = moment();
const initial = {
  // status: 'active',
  start_at: d.startOf('day').format(),
  start_to: d.endOf('day').format(),
};

export const Test = reduxForm({
  form: 'testForm',
  // destroyOnUnmount: false,
  initialValues: initial,
})(TestForm);
